module.exports = __webpack_public_path__ + "images/emoji/two_men_holding_hands.92a77707935367caaa89.png";